import { memo, useMemo } from "react";
import { IoTennisball } from "react-icons/io5"; // Ionicons tennisball
import { levelColors, secondary } from '../../../assets/coach-assets/constants/colors'
import { fontType } from "../../../assets/extras";

const ClinicCard = ({ data, onPress }) => {
  //Formatea el subtitulo
  const subtitle = useMemo(() => {
    if (data.id.split("-").length === 1 || data.id.split("-")[2] === "TEMP") {
      let dias = ""
      let hora = ""
      data.dias_clase.map(v => {
        let dia = ""
        for (let i = 0; i < 3; i++) {
          dia += v.dia[i]
        }
        if (dias) {
          dias += " / " + dia
        } else {
          dias = dia
          hora = v.de + " a " + v.a
        }
      })
      return dias + " de " + hora
    }
    return ""
  }, [data.dias_clase])

  const type = data.id.split("-")[2];
  let label = data.nombre_clase;
  if (type === "TEMP") label += " (SUST)";
  if (type === "EXT") label += " (EXT)";

  return (
    <div style={{ width: "100%", marginBottom: 30, padding: 10, maxWidth: 300, minWidth: 250 }}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", fontFamily: fontType.title }}>
        <span style={{ fontSize: 20, fontWeight: "bold" }}>{label}</span>
        {type !== "EXT" && (
          <IoTennisball size={24} color={
            data.nivel === "Etapa roja" ? levelColors.Etapa_roja :
              data.nivel === "Etapa naranja" ? levelColors.Etapa_naranja :
                data.nivel === "Etapa verde" ? levelColors.Etapa_verde :
                  data.nivel === "Clase D" ? levelColors.Clase_D :
                    data.nivel === "Clase C" ? levelColors.Clase_C :
                      data.nivel === "Clase B" ? levelColors.Clase_B :
                        data.nivel === "Clase A" ? levelColors.Clase_A :
                          data.nivel === "Profesional" ? levelColors.Profesional : "black"
          } />
        )}
      </div>

      <button
        onClick={() => onPress(data)}
        style={{
          backgroundColor: secondary,
          marginTop: 5,
          borderRadius: 5,
          padding: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          height: 100,
          width: "100%",
          border: "1px solid #ccc",
          cursor: "pointer",
          flexDirection: "column",
          fontFamily: fontType.text
        }}
      >
        <span style={{ fontSize: 16, color: "black", marginBottom: 10 }}>{data.descripcion_clase}</span>
        {type !== "EXT" && <span style={{ width: "100%", fontWeight: "bold", textAlign: "right", fontSize: 14 }}>{subtitle}</span>}
      </button>
    </div>
  );
};

export default memo(ClinicCard);
